module.exports = __webpack_public_path__ + "img/about-m-slide-26.0e08ce2f.jpg";